<template>
  <div class="product-courses-page">
    <!-- 1. Banner Section -->
    <div class="banner-section">
      <div class="banner-content">
        <div class="banner-text">
          <h1 class="banner-title">{{ bannerTitle }}</h1>
          <p class="banner-desc">
            {{ bannerDesc }}
          </p>
        </div>
        <div class="banner-image-wrapper">
          <img src="@/assets/product/courses/banner.png"
               :alt="bannerAlt"
               class="banner-img" />
        </div>
      </div>
    </div>

    <!-- 2. Course Kits/Tabs Section -->
    <div class="tabs-section">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">{{ sections.kitsTitle }}</h2>
          <p class="section-desc">{{ sections.kitsDesc }}</p>
        </div>

        <!-- Tabs -->
        <div class="course-tabs">
          <div class="tab-item"
               v-for="(tab, index) in courseTabs"
               :key="index"
               @click="currentTabIndex = index"
               :class="{ active: currentTabIndex === index }"
               :style="currentTabIndex === index ? { backgroundColor: tab.activeColor, color: '#fff' } : {}">
            {{ tab.name }}
          </div>
        </div>

        <!-- Content Card -->
        <div class="tab-content-card"
             v-if="currentTab">
          <div class="tab-text-area">
            <h3 class="tab-content-title">{{ currentTab.title }}</h3>
            <p class="tab-content-desc">{{ currentTab.desc }}</p>
          </div>
          <div class="tab-image-area">
            <img :src="currentTab.image"
                 :alt="currentTab.title"
                 class="tab-content-img" />
          </div>
        </div>
      </div>
    </div>

    <!-- 3. Introduction Section (Icon Grid) -->
    <div class="intro-section">
      <div class="section-container">
        <div class="intro-grid">
          <div class="intro-item"
               v-for="(item, index) in introItems"
               :key="index">
            <div class="intro-icon-wrapper">
              <img :src="item.icon"
                   :alt="item.title"
                   class="intro-icon" />
            </div>
            <div class="intro-text">
              <h3 class="intro-title">{{ item.title }}</h3>
              <p class="intro-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 4. Course List Section (Alternating Layout) -->
    <div class="course-list-section">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">{{ sections.seriesTitle }}</h2>
        </div>

        <div class="course-grid">
          <!-- Row 1: Text Top, Image Bottom -->
          <div class="course-item type-a"
               v-for="(course, index) in courseListRow1"
               :key="'r1-'+index">
            <div class="course-name">{{ course.name }}</div>
            <div class="course-img-wrapper">
              <img :src="course.image"
                   :alt="course.name"
                   class="course-img">
            </div>
          </div>

          <!-- Row 2: Image Top, Text Bottom -->
          <div class="course-item type-b"
               v-for="(course, index) in courseListRow2"
               :key="'r2-'+index">
            <div class="course-img-wrapper">
              <img :src="course.image"
                   :alt="course.name"
                   class="course-img">
            </div>
            <div class="course-name">{{ course.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 5. Bottom Banner Section -->
    <div class="bottom-banner-section">
      <div class="bottom-banner-container">
        <div class="bottom-banner-image-wrapper">
          <img src="@/assets/product/courses/bottombanner.png"
               :alt="bottomBannerAlt"
               class="bottom-banner-img">
        </div>
        <div class="bottom-banner-text">
          <p>
            {{ bottomBannerText }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCourses',
  data() {
    return {
      currentTabIndex: 0,
      courseTabAssets: [
        {
          activeColor: '#4285F4',
          image: require('@/assets/product/courses/course1.png')
        },
        {
          activeColor: '#4285F4',
          image: require('@/assets/product/courses/course2.png')
        },
        {
          activeColor: '#4285F4',
          image: require('@/assets/product/courses/course3.png')
        },
        {
          activeColor: '#4285F4',
          image: require('@/assets/product/courses/course4.png')
        },
      ],
      introAssets: [
        { icon: require('@/assets/product/courses/icon1.png') },
        { icon: require('@/assets/product/courses/icon2.png') },
        { icon: require('@/assets/product/courses/icon3.png') },
        { icon: require('@/assets/product/courses/icon4.png') },
        { icon: require('@/assets/product/courses/icon5.png') },
        { icon: require('@/assets/product/courses/icon6.png') }
      ],
      courseListRow1Assets: [
        { image: require('@/assets/product/courses/ai1.png') },
        { image: require('@/assets/product/courses/ai2.png') }
      ],
      courseListRow2Assets: [
        { image: require('@/assets/product/courses/ai3.png') },
        { image: require('@/assets/product/courses/ai4.png') }
      ],
    }
  },
  computed: {
    productCoursesCopy() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
      const messages =
        this.$i18n && this.$i18n.getLocaleMessage
          ? this.$i18n.getLocaleMessage(locale)
          : {}
      return (messages.product && messages.product.courses) || {}
    },
    bannerTitle() {
      return this.productCoursesCopy.bannerTitle || ''
    },
    bannerDesc() {
      return this.productCoursesCopy.bannerDesc || ''
    },
    bannerAlt() {
      return this.productCoursesCopy.bannerAlt || this.bannerTitle
    },
    bottomBannerAlt() {
      return this.productCoursesCopy.bottomBannerAlt || this.bannerTitle
    },
    sections() {
      return this.productCoursesCopy.sections || {}
    },
    courseTabs() {
      const tabs = this.productCoursesCopy.courseTabs || []
      return tabs.map((item, index) => {
        const asset = this.courseTabAssets[index] || {}
        return {
          name: item.name || '',
          activeColor: asset.activeColor || '#4285F4',
          data: {
            title: item.title || '',
            desc: item.desc || '',
            image: asset.image || '',
          },
        }
      })
    },
    introItems() {
      const items = this.productCoursesCopy.introItems || []
      return items.map((item, index) => {
        const asset = this.introAssets[index] || {}
        return {
          title: item.title || '',
          desc: item.desc || '',
          icon: asset.icon || '',
        }
      })
    },
    courseListRow1() {
      const items = this.productCoursesCopy.courseListRow1 || []
      return items.map((item, index) => {
        const asset = this.courseListRow1Assets[index] || {}
        return {
          name: item.name || '',
          image: asset.image || '',
        }
      })
    },
    courseListRow2() {
      const items = this.productCoursesCopy.courseListRow2 || []
      return items.map((item, index) => {
        const asset = this.courseListRow2Assets[index] || {}
        return {
          name: item.name || '',
          image: asset.image || '',
        }
      })
    },
    bottomBannerText() {
      return this.productCoursesCopy.bottomBannerText || ''
    },
    currentTab() {
      return this.courseTabs[this.currentTabIndex].data;
    }
  }
}
</script>

<style scoped>
.product-courses-page {
  width: 100%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

/* 1. Banner Section */
.banner-section {
  width: 100%;
  height: 680px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.banner-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.banner-text {
  width: 50%;
  padding-left: calc((100% - 1200px) / 2);
  padding-right: 50px;
  box-sizing: border-box;
}

.banner-title {
  font-size: 48px;
  color: #333;
  font-weight: bold;
  margin-bottom: 30px;
}

.banner-desc {
  font-size: 24px;
  color: #666;
  line-height: 1.6;
}

.banner-image-wrapper {
  width: 50%;
  height: 680px;
  display: flex;
  justify-content: flex-end;
}

.banner-img {
  width: 1083px;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 1900px) {
  .banner-section {
    height: 560px;
  }

  .banner-text {
    padding-left: 60px;
    padding-right: 40px;
  }

  .banner-title {
    font-size: 40px;
    margin-bottom: 20px;
  }

  .banner-desc {
    font-size: 20px;
  }

  .banner-image-wrapper {
    height: 560px;
  }

  .banner-img {
    width: 885px;
    object-fit: contain;
  }
}

@media (max-width: 1366px) {
  .banner-section {
    height: 520px;
  }

  .banner-content {
    padding: 0 40px;
  }

  .banner-text {
    width: 52%;
    padding-left: 0;
    padding-right: 24px;
  }

  .banner-title {
    font-size: 36px;
    margin-bottom: 16px;
  }

  .banner-desc {
    font-size: 18px;
  }

  .banner-image-wrapper {
    width: 48%;
    height: 520px;
    justify-content: center;
  }

  .banner-img {
    width: 100%;
    max-width: 640px;
  }
}

@media (max-width: 1200px) {
  .banner-section {
    height: auto;
    padding: 60px 0;
  }

  .banner-content {
    flex-direction: column;
    gap: 30px;
  }

  .banner-text {
    width: 100%;
    padding: 0 32px;
  }

  .banner-title {
    font-size: 34px;
  }

  .banner-desc {
    font-size: 18px;
  }

  .banner-image-wrapper {
    width: 100%;
    height: 360px;
    justify-content: center;
  }

  .banner-img {
    width: 90%;
    max-width: 720px;
    height: 100%;
  }
}

/* 2. Tabs Section */
.tabs-section {
  width: 100%;
  height: 1119px;
  background-color: #f2f2f2;
  padding-top: 80px;
}

.section-container {
  width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 34px;
  color: #333;
  font-weight: bold;
  margin-bottom: 20px;
}

.section-desc {
  font-size: 18px;
  color: #666;
}

.course-tabs {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 60px;
}

.tab-item {
  font-size: 20px;
  color: #333;
  cursor: pointer;
  padding: 0 40px;
  height: 63px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 94px;
  transition: all 0.3s ease;
  min-width: 200px;
}

.tab-item:hover {
  background-color: #e0e0e0;
}

.tab-item.active {
  color: #fff;
}

.tab-content-card {
  width: 1200px;
  height: 662px;
  background-color: #fff;
  border-radius: 85px;
  display: flex;
  overflow: hidden;
}

.tab-text-area {
  width: 514px;
  height: 100%;
  padding: 100px 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tab-content-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}

.tab-content-desc {
  font-size: 18px;
  color: #666;
  line-height: 1.8;
}

.tab-image-area {
  width: 686px;
  height: 100%;
}

.tab-content-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 3. Intro Section */
.intro-section {
  width: 100%;
  height: 921px;
  background-color: #fff;
  padding-top: 100px;
}

.intro-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  justify-items: center;
}

.intro-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;
}

.intro-icon-wrapper {
  width: 157px;
  height: 157px;
  margin-bottom: 10px;
}

.intro-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.intro-text {
  width: 254px;
  height: 147px;
}

.intro-title {
  font-size: 20px;
  color: #333;
  font-weight: normal;
  margin-bottom: 15px;
}

.intro-desc {
  font-size: 20px;
  color: #666;
  line-height: 1.5;
  text-align: justify;
}

/* 4. Course List Section */
.course-list-section {
  width: 100%;
  height: 1215px;
  background-color: #f4f6fa;
  padding-top: 80px;
}

.course-grid {
  margin-top: 60px;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 items per row */
  gap: 30px;
  row-gap: 60px;
}

.course-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.course-item.type-a {
  /* Text Top, Image Bottom */
  flex-direction: column;
}

.course-item.type-b {
  /* Image Top, Text Bottom */
  flex-direction: column;
}

.course-name {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px; /* For Type A */
  margin-top: 20px; /* For Type B */
}

/* Fix margins based on type */
.course-item.type-a .course-name {
  margin-bottom: 20px;
  margin-top: 0;
}

.course-item.type-b .course-name {
  margin-top: 20px;
  margin-bottom: 0;
}

.course-img-wrapper {
  width: 100%;
  aspect-ratio: 4/3; /* Adjust as needed */
  border-radius: 20px;
  overflow: hidden;
  background-color: #eee;
}

.course-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 5. Bottom Banner Section */
.bottom-banner-section {
  width: 100%;
  height: 775px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.bottom-banner-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: flex-end; /* Align content to right for text */
}

.bottom-banner-image-wrapper {
  position: absolute;
  left: 0;
  top: 0; /* Ensure top alignment */
  width: 959px;
  height: 94%; /* Match container height */
}

.bottom-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bottom-banner-text {
  width: 400px;
  position: relative; /* Change to relative to interact with flex container if needed, or keep absolute */
  z-index: 2; /* Ensure text is above image */
  /* Optional: add background for readability if overlapping */
  padding: 40px;
  border-radius: 20px; /* Rounded corners for text box */
  margin-right: 100px; /* Align to right */
}
</style>
